module.exports = __webpack_public_path__ + "static/img/search_subcat_item_06_show.68d48e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_06_show.jpg
// module id = Vnzf
// module chunks = 0